import SpatialReference from '@arcgis/core/geometry/SpatialReference';
import * as projection from '@arcgis/core/geometry/projection';
import Geometry from '@arcgis/core/geometry/Geometry';

export class CoordinateConverterService {
    constructor() {}

    /**
     * Convert inGeometry to some output spatial reference by wkid (lat/long is wkid = 4326).
     * @param inGeometry
     * @param outWkid
     */
    public static convertEsriGeometry(inGeometry: Geometry | Geometry[], outWkid: number): Geometry | Geometry[] {
        const outSpatialReference = new SpatialReference({
            wkid: outWkid,
        });
        return projection.project(inGeometry, outSpatialReference);
    }
}
